import React from 'react';
import { DropdownMenuSeparator } from '@/components/ui/dropdown-menu';

const ErpDropdownDivider: React.FC = () => {
  return <DropdownMenuSeparator />;
};

export default ErpDropdownDivider;
